import {selectNavOption} from "../helpers/nav_option_helpers";
import {clearNavOption, setRenderMapBounds} from "../helpers/commit_helpers";

// When the nav option is clicked (via the Nav's `PaneOptionComponent`) we change the URL without calling the route handler (using the `callHandler` option) and then we do the same work as the route handler would.
// However, unlike the route handlers we don't call the Nav Option's `fireSelectedWithRouteRequestEvent` method.
// This is important because firing that would trigger the Nav's `PaneOptionComponent` to handle the event -
// which is not necessary as the initial `click` event on the Nav's `PaneOptionComponent` will do it's thing appropriately.
export default function navOptionClicked(sm, navOption) {

    if (navOption.experience && navOption.mapFilter) {

        // For experience nav options, let the route handler do all the work.
        // It looks up the full MapFilter and Experience from collections (which have experienceIds and experienceMarker).
        navOption.onlineApp.onlineAppRouter.navigateToFilterExperience(navOption.mapFilter, navOption.experience, { callHandler: true });

    } else if (navOption.mapFilter) {

        // Change the URL to the filter route without calling the route handler — UNLESS a deep-linked
        // initial route is still pending. The shared Nav webview fires this boot click BEFORE
        // `handleInitialAppPath()` resolves the deep path, so writing the persisted/default filter URL
        // here would clobber the deep link. Skip only the URL write; still do the state work below.
        if (!navOption.onlineApp.hasPendingInitialRoute()) {
            navOption.onlineApp.onlineAppRouter.navigateToFilter(navOption.mapFilter, { callHandler: false });
        }

        selectNavOption(sm, navOption);

    } else if (navOption.subpage) {

        // Change the URL to the subpage route without calling the route handler — UNLESS a deep-linked
        // initial route is still pending (see the filter branch above for why).
        if (!navOption.onlineApp.hasPendingInitialRoute()) {
            navOption.onlineApp.onlineAppRouter.navigateToSubpage(navOption.subpage, { callHandler: false });
        }

        selectNavOption(sm, navOption);

    } else if (navOption) {
        selectNavOption(sm, navOption);
    } else {
        if (!!sm.state['navOption']) clearNavOption(sm);
    }

}